import PropTypes from 'prop-types';
import BaseCesiumViewer from './BaseCesiumViewer';

/**
 * 3D Cesium Viewer Component
 * Displays Cesium 3D tilesets with measurement tools and visualization controls
 *
 * @param {number} id - Cesium Ion asset ID for the point cloud tileset
 * @param {string} token - Cesium Ion access token
 * @param {number} gaussianSplattingId - Cesium Ion asset ID for Gaussian splatting (optional)
 */
function CesiumViewer({
  id,
  token,
  gaussianSplattingId,
  resultsAssetId,
  transformationPointsId,
  transformationPointsStr,
  transformationGsId,
  transformationGsStr,
}) {
  return (
    <BaseCesiumViewer
      id={id}
      token={token}
      gaussianSplattingId={gaussianSplattingId}
      resultsAssetId={resultsAssetId}
      transformationPointsId={transformationPointsId}
      transformationPointsStr={transformationPointsStr}
      transformationGsId={transformationGsId}
      transformationGsStr={transformationGsStr}
    />
  );
}

CesiumViewer.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  token: PropTypes.string.isRequired,
  gaussianSplattingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  transformationPointsId: PropTypes.number,
  transformationPointsStr: PropTypes.string,
  transformationGsId: PropTypes.number,
  transformationGsStr: PropTypes.string,
};

export default CesiumViewer;
